/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * §14.3: Channel kind for `AlertChannelConfig`. Maps to FE `channel_type: \'email\' | \'slack\' | \'teams\' | \'webhook\' | \'sms\'`.
 */
export enum AlertChannelType {

    Email = 'email',

    Slack = 'slack',

    Teams = 'teams',

    Webhook = 'webhook',

    Sms = 'sms'
}
